(function () {
  const SIGNATURE_VARIANT_ID = 51600015655210;

  function initDeliveryOption() {
    const radios = document.querySelectorAll('input[name="delivery_choice"]');
    if (!radios.length) return;

    // Prevent duplicate listeners by cloning and replacing radios safely
    radios.forEach(radio => {
      const newRadio = radio.cloneNode(true);
      radio.parentNode.replaceChild(newRadio, radio);
    });

    // Get fresh references after cloning
    const freshRadios = document.querySelectorAll('input[name="delivery_choice"]');
    const atlWrap = document.getElementById('atl-instructions-wrap');
    const atlTextarea = document.getElementById('atl-instructions');
    const error = document.getElementById('delivery-error');

    freshRadios.forEach(radio => {
      radio.addEventListener('change', async function () {
        const choice = this.value;

        if (error) error.style.display = 'none';

        // Toggle visual UI fields immediately
        if (choice.includes('ATL')) {
          if (atlWrap) atlWrap.style.display = 'block';
        } else {
          if (atlWrap) atlWrap.style.display = 'none';
          if (atlTextarea) atlTextarea.value = '';
        }

        try {
          // ALWAYS update root attributes first via /cart/update.js
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                delivery_option: choice,
                atl_instructions: choice.includes('Signature') ? '' : (atlTextarea ? atlTextarea.value : '')
              }
            })
          });

          if (choice.includes('Signature')) {
            // Check if fee already exists to prevent duplicates
            const cartCheck = await fetch('/cart.js').then(r => r.json());
            const alreadyAdded = cartCheck.items.find(i => i.variant_id === SIGNATURE_VARIANT_ID);
            if (!alreadyAdded) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: SIGNATURE_VARIANT_ID, quantity: 1 }]
                })
              });
            }
          } else {
            const cartData = await fetch('/cart.js').then(r => r.json());
            const feeItem = cartData.items.find(i => i.variant_id === SIGNATURE_VARIANT_ID);
            if (feeItem) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: feeItem.key, quantity: 0 })
              });
            }
          }
        } catch (err) {
          console.error("Cart update error:", err);
        }

        // Refresh cart
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.reload();
        }
      });
    });

    // Block checkout
    const checkoutBtns = document.querySelectorAll(
      '[name="checkout"], a[href="/checkout"], button[data-checkout]'
    );
    checkoutBtns.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.addEventListener('click', function (e) {
        const selected = document.querySelector('input[name="delivery_choice"]:checked');
        if (!selected) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (error) error.style.display = 'block';
          document.getElementById('delivery-option-wrap')?.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    // Save ATL instructions on blur
    if (atlTextarea) {
      atlTextarea.onblur = async function () {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { atl_instructions: this.value }
          })
        });
      };
    }
  }

  // Initial runtime activation
  initDeliveryOption();

  // Re-run on theme triggers
  document.addEventListener('cart:open', initDeliveryOption);
  document.addEventListener('cart:updated', initDeliveryOption);

  // MutationObserver for drawer re-renders
  const observer = new MutationObserver(function () {
    initDeliveryOption();
  });

  const drawerTarget = document.querySelector(
    '#cart-drawer, #CartDrawer, .cart-drawer, [id*="cart-drawer"]'
  );
  if (drawerTarget) {
    observer.observe(drawerTarget, { childList: true, subtree: true });
  }
})();